import { render, staticRenderFns } from "./LayoutBlank2.vue?vue&type=template&id=cdcac93e&"
import script from "./LayoutBlank2.vue?vue&type=script&lang=js&"
export * from "./LayoutBlank2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports